import { appStore } from '../../app/AppStore';
import { selectContentFromAppState } from '../../app/selectors/ContentSelectors';
import { BackgroundJobStatus, BackgroundJobTaskType } from './BackgroundJobInfo';
import { IExplorableItemTypeInfo } from '../../ts/models/resourceInfoParts';
import { Module } from '../../ts/Module';
import { CancelBackgroundJobRequest, ICancelBackgroundJobParams } from './CancelBackgroundJobRequest';
import { GetBackgroundJobsRequest, IGetBackgroundJobsResult } from './GetBackgroundJobsRequest';
import { BackgroundJobAllowedActions } from './BackgroundJobAllowedActions';
import { IBackgroundJob } from './IBackgroundJob';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../../ts/services/ErrorNotifyingServer';
import { FetcherFactory } from '../../ts/services/FetcherFactory';
import { IActionResource, Resource } from '../../ts/resources/Resource';

export interface IBackgroundJobInfo extends IBackgroundJob, IExplorableItemTypeInfo<'backgroundJob'> {
}


export class BackgroundJobs extends Resource<IBackgroundJobInfo> implements IActionResource<BackgroundJobAllowedActions> {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory', '$q'];

  constructor(
    private ErrorNotifyingServer: ErrorNotifyingServer,
    FetcherFactory: FetcherFactory,
    private $q: ng.IQService,
    ) {
    super(FetcherFactory.getServerResourceFetcher(
      GetBackgroundJobsRequest,
      (result: IGetBackgroundJobsResult): IBackgroundJobInfo[] => result.backgroundJobs.map((j: IBackgroundJob) => {
        return {
          ...j,
          contentType: 'backgroundJob',
          id: j.jobId + '',
        } as IBackgroundJobInfo; // Typescript can't infer whether 'backgroundJobs' is a string or 'backgroundJobs'
      })
    ));
  }

  public actions(id: string): ng.IPromise<BackgroundJobAllowedActions> {
    const items = selectContentFromAppState(appStore.getState());
    const backgroundJob: IBackgroundJobInfo | undefined = items.find((item: IBackgroundJobInfo) => item.jobId + '' === id) as IBackgroundJobInfo;
    if (!backgroundJob) {
      throw new Error('Failed to find background job with id ' + backgroundJob.jobId);
    }
    const incomplete = backgroundJob.status === BackgroundJobStatus.Pending || backgroundJob.status === BackgroundJobStatus.InProgress;
    const isSystemJob = backgroundJob.taskType === BackgroundJobTaskType.System;
    const cancelBackgroundJob = incomplete && !isSystemJob;
    return this.$q.resolve({ cancelBackgroundJob });
  }

  public cancelBackgroundJob(cancelParms: ICancelBackgroundJobParams): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequestAndDelay(new CancelBackgroundJobRequest(cancelParms));
  }
}

Module.instance().service('BackgroundJobs', BackgroundJobs);
